module.exports = __webpack_public_path__ + "img/emc_waxtokenemc2.be4ab2f.png";